import React from "react";
import BrandedLoader from "src/components/shared/atoms/BrandedLoader";

const ScreenLoader = () => {
  return <BrandedLoader />;
};

export default ScreenLoader;
